import { HttpError, errorFields, shouldRetry as sharedShouldRetry } from '../../api';

export class AccessError extends HttpError {
  constructor(status: number, message: string, code: string | null) {
    super({ status, message, code });
    this.name = 'AccessError';
  }
}

export const errorFrom = (status: number, data: unknown): AccessError => {
  const { message, code } = errorFields(data);
  return new AccessError(status, message, code);
};

export const shouldRetry = sharedShouldRetry;
